import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IconComponent } from './icon.component';

const components = [IconComponent];

@NgModule({
  declarations: components,
  exports: components,
  imports: [CommonModule],
})
export class IconModule {}
